export const gitVersion = '1.0.1-230-g7052d20';
